import { IOffer } from 'shared/offer';
import { EActionType } from 'shared/repositories/search-offers.legacy/v2/types/dailyrentData';

export const isCianPartner = (offer: IOffer) => {
  return (
    !!offer.dailyrent &&
    [EActionType.PartnerBooking, EActionType.PartnerCheckDates].includes(offer.dailyrent.actionType)
  );
};
